import {Flex, Text} from '@priority-software/priority-style-react';
import React, {PropsWithChildren} from 'react';
import styles from '../styles.module.scss';

interface ILabelWrapperProps extends PropsWithChildren {
    label: string;
}

export const LabelWrapper: React.FC<ILabelWrapperProps> = ({children, label}) => {
    return (
        <Flex componentClasses={styles.labelWrapperContainer} direction="column">
            <Text componentClasses={styles.fullWidth} skin="label-1">
                {label}
            </Text>
            {children}
        </Flex>
    );
};
